import { ToastContainer } from "react-toastify";
import AppRouter from "./routes/AppRouter";
import { SessionProvider } from "./context/SessionContext";
import useCheckAppVersion from "./hooks/useCheckAppVersion";

function App() {
	useCheckAppVersion(60000);

	return (
		<SessionProvider>
			<AppRouter />
			<ToastContainer
				position="top-center"
				autoClose={3000}
				hideProgressBar={false}
				pauseOnHover
				stacked
				newestOnTop={false}
				closeOnClick={false}
				pauseOnFocusLoss
				draggable
				theme="light"
			/>
		</SessionProvider>
	);
}

export default App;
